<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>

      <div class="row">
        <div class="col-12 mb-2">
          <auto-complete :get-data="loadClients" :result="clientSelected" :item-text="itemText" placeholder="Sisesta nimi või kood..."/>
        </div>
      </div>

      <div class="row">

        <div class="col-6">
          <div class="data-list">
            <dl>
              <dt>Käesolev saaja</dt>
              <dd>{{invoice.client.name}}</dd>
            </dl>
          </div>
        </div>

        <div class="col-6">
          <div class="data-list">
            <dl>
              <dt>Uus saaja</dt>
              <dd v-if="client">{{client.name}}</dd>
              <dd v-if="!client">-</dd>
            </dl>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-12">
          <submit-button class="float-right" variant="primary" :disabled="!client">Kinnita saaja vahetus</submit-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import gateway from '@/services/gateway'
  import AutoComplete from '@/components/AutoComplete'

  export default {
    props: ['invoice'],
    components: {AutoComplete},
    data() {
      return {
        client: null
      }
    },
    methods: {
      loadClients(query) {
        return gateway.get('/clients?query=' + query).then(r => r.data)
      },
      clientSelected(item) {
        this.client = item
      },
      itemText(item) {
        return item.name
      },
      submit() {
        gateway
          .post(`/invoices/${this.invoice.id}/change-client`, {clientId: this.client.id})
          .then(() => {
            this.$notifications.info(`Arve saaja on vahetatud. Uus saaja on ${this.client.name}`)
            this.$emit('done')
          })
      }
    }
  }
</script>
